import React from 'react';
import { Helmet } from 'react-helmet';
import Banner from './components/Homepage/banner/Bannerbox';
import CardContainer from './components/Homepage/card/Card';
import Showcasing from './components/Homepage/Showcasing/Showcasing';
import WearToRepair from './components/Homepage/Showcasing/WearToRepair';
import HomeRedsign from './components/Homepage/HomeRedesign/homeredesign';

const Homepage = () => {
  return (
    <div>
      <Helmet>
        <title>Sabiote | Supplier of Surgical Consumables</title>
      </Helmet>
      {/* <Banner />
      <CardContainer />
      <WearToRepair />
      <Showcasing /> */}
      <HomeRedsign/>
    </div>
  );
}

export default Homepage;
